import { ExpandableText } from '@/components/composed';
import { Text } from '@/design-system/components/ui';

import { AffiliateApplicationFormFieldType } from '../domain/affiliate-application-types';

type FormResponseValue = string | number | boolean | string[] | undefined;

const formatFieldValue = (value: FormResponseValue): string => {
  if (value === undefined || value === null) return '-';
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';
  if (Array.isArray(value)) return value.join(', ');
  return String(value);
};

const isValidUrl = (value: string): boolean => {
  try {
    new URL(value);
    return true;
  } catch {
    return false;
  }
};

interface Props {
  /** Field label — used as the title of the "Read more" dialog. */
  label: string;
  value: FormResponseValue;
  type: AffiliateApplicationFormFieldType;
  /** Identifying context (e.g. User + Date) shown under the dialog title. */
  details?: { label: string; value: React.ReactNode }[];
}

export const FormResponseCell = ({ label, value, type, details }: Props) => {
  if (value === undefined || value === null) {
    return (
      <Text variant="body-md" color="muted">
        -
      </Text>
    );
  }

  if (type === 'url' && typeof value === 'string' && isValidUrl(value)) {
    return (
      <a
        href={value}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => e.stopPropagation()}
        className="tw:block tw:max-w-[320px] tw:truncate tw:text-fuul-blue tw:underline tw:underline-offset-4"
      >
        {value}
      </a>
    );
  }

  return <ExpandableText label={label} text={formatFieldValue(value)} details={details} />;
};
